module.exports = __webpack_public_path__ + "static/img/logo_pix.42cf478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_pix.png
// module id = TcMn
// module chunks = 1